import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { loadCookie, SasCookieKeys } from 'common/utils/cookie-utils';

import { BoardStatus, boardState, setStatus } from 'common/modules/app/board';
import { GlossaryState } from 'common/modules/app/glossaries';
import { Glossary } from 'common/utils/glossary';
import { FetchState, FetchStatus } from 'common/modules/app/fetch';
import {
  deleteLendingReturn,
  DELETE_LENDING_RETURN_ID
} from 'common/modules/domain/lendingUser';
import { UserInformation } from 'common/modules/domain/user';
import { AppState } from 'pages';
import { CancellationConfirmationDialog } from 'pages/board/components/CancellationConfirmationDialog';

/**
 * StoreのStateからComponentに渡すPropsへ
 */
const useStateProps = () => {
  const boardState = useSelector<AppState, boardState>(
    (state) => state.app.board
  );
  const glState = useSelector<AppState, GlossaryState>(
    (state) => state.app.glossaries
  );
  const userState = useSelector<AppState, UserInformation>(
    (state) => state.domain.user
  );
  const fetchState = useSelector<AppState, FetchState>(
    (state) => state.app.fetch
  );

  const isProcessing =
    fetchState[DELETE_LENDING_RETURN_ID] !== null &&
    fetchState[DELETE_LENDING_RETURN_ID] === FetchStatus.PROCESSING;

  return {
    board: boardState,
    glossary: Glossary.instance(glState),
    user: userState,
    isProcessing: isProcessing
  };
};

type SelectedState = ReturnType<typeof useStateProps>;
/**
 * StoreのStateとActionをdispatchする関数からComponentに渡すPropsへ
 */
const useMargeProps = (state: SelectedState) => {
  const dispatch = useDispatch();
  const _board = state.board;
  /** CancellationConfirmationDialogの表示有無 */
  const _isDisplay =
    _board.status === BoardStatus.CANCELLATION_CONFIRMATION_DISP;
  /** SASトークン取得 */
  const cookie = loadCookie();
  const _token = cookie[SasCookieKeys.KEY_TOKEN];
  const _refreshToken = cookie[SasCookieKeys.KEY_REFRESH_TOKEN];
  /** 選択中のユーザー購入番号取得 */
  const _purchaseId = state.board.selectedPurchaseIdForReturn;

  /** "OKボタン"の押下処理 */
  const onClickOk = () => {
    // 第三者利用権返却APIを実行
    dispatch(deleteLendingReturn(_token, _refreshToken, _purchaseId, false));
  };

  /** "キャンセルボタン"の押下処理 */
  const onClickCancel = () => {
    dispatch(setStatus(BoardStatus.NOT_DISP));
  };

  return {
    isDisplay: _isDisplay,
    glossary: state.glossary,
    isProcessing: state.isProcessing,
    onClickOk: onClickOk,
    onClickCancel: onClickCancel
  };
};

/**
 * 利用解除確認ダイアログ全体のContainer Component
 */
export default function ContainerComponent(ownProps: { isMobile?: boolean }) {
  const _props = { ...useStateProps(), ...useMargeProps(useStateProps()) };
  return <CancellationConfirmationDialog {...{ ..._props, ...ownProps }} />;
}
